import { Vacancy } from '../models';
import { LocationFinishDTO } from '../models/dtos/movements/location-finishDTO';
import {
  MovementExecutionDestinyDTO,
  MovementExecutionDestinyDTOLocation,
} from '../models/dtos/movements/execution-destiny/movement-execution-destiny-dto';
import { MovementLocation } from '../models/movement/movement-location';

/**
 * EM-2589: local (e vaga) do FINISH de uma etapa disparada pelo mapa de vagas, a partir dos destinos que o backend
 * calcula para a etapa (GET .../movement-plan/{planId}/movement/{movementId}/destiny), do mesmo jeito que o modal
 * "Finalização de movimentação" monta o padrão. Nunca usa id de local fixo: o local é sempre o da marina.
 *
 * Regras (destinos de MovementExecutionQueryUseCase.destinies; `chooseDestiny` só é falso com um único local sem vagas
 * nem controle de vaga, ou com o local fixo do barco):
 * - `chooseDestiny = false`: o destino é o que o backend calculou (`locations[0]`), com a vaga clicada se estiver lá,
 *   senão a primeira vaga devolvida;
 * - `chooseDestiny = true`: só finaliza se a vaga clicada no mapa estiver entre os destinos; o mapa não escolhe local
 *   nem vaga pelo operador.
 * Devolve `null` quando o mapa não pode decidir (o operador conclui pela tela de Movimentação).
 */
export function resolveLocationFinish(
  destinies: MovementExecutionDestinyDTO,
  preferredVacancyId?: number
): LocationFinishDTO | null {
  const locations: MovementExecutionDestinyDTOLocation[] = destinies?.locations || [];
  if (locations.length === 0) {
    return null;
  }
  const isPreferred = (id: number) => preferredVacancyId != null && Number(id) === Number(preferredVacancyId);

  let location: MovementExecutionDestinyDTOLocation;
  let vacancy: any;
  if (destinies.chooseDestiny) {
    location = locations.find((l) => (l.vacancies || []).some((v) => isPreferred(v.id)));
    if (!location) {
      return null;
    }
    vacancy = location.vacancies.find((v) => isPreferred(v.id));
  } else {
    location = locations[0];
    const vacancies = location.vacancies || [];
    vacancy = vacancies.find((v) => isPreferred(v.id)) || vacancies[0];
  }

  if (location.vacancyControl && !vacancy) {
    return null;
  }
  const finish: LocationFinishDTO = {
    movementLocation: { id: location.id, type: location.type } as MovementLocation,
  };
  if (vacancy) {
    finish.vacancy = vacancy as Vacancy;
  }
  return finish;
}
